import {
    UPLOAD_BATCH_LIST_REQUEST, UPLOAD_BATCH_LIST_SUCCESS, UPLOAD_BATCH_LIST_FAIL,
    UPLOAD_BATCH_DETAILS_REQUEST, UPLOAD_BATCH_DETAILS_SUCCESS, UPLOAD_BATCH_DETAILS_FAIL, UPLOAD_BATCH_DETAILS_RESET,
    UPLOAD_BATCH_CREATE_REQUEST, UPLOAD_BATCH_CREATE_SUCCESS, UPLOAD_BATCH_CREATE_FAIL, UPLOAD_BATCH_CREATE_RESET,
    UPLOAD_BATCH_UPDATE_REQUEST, UPLOAD_BATCH_UPDATE_SUCCESS, UPLOAD_BATCH_UPDATE_FAIL, UPLOAD_BATCH_UPDATE_RESET,
    UPLOAD_BATCH_DELETE_REQUEST, UPLOAD_BATCH_DELETE_SUCCESS, UPLOAD_BATCH_DELETE_FAIL, UPLOAD_BATCH_DELETE_RESET,
    UPLOAD_BATCH_DTO_REQUEST, UPLOAD_BATCH_DTO_SUCCESS, UPLOAD_BATCH_DTO_FAIL, UPLOAD_BATCH_DTO_RESET,
    UPLOAD_BATCH_LIST_BY_IDS_REQUEST, UPLOAD_BATCH_LIST_BY_IDS_SUCCESS, UPLOAD_BATCH_LIST_BY_IDS_FAIL,
    UPLOAD_BATCH_BY_ORGANISATION_REQUEST, UPLOAD_BATCH_BY_ORGANISATION_SUCCESS, UPLOAD_BATCH_BY_ORGANISATION_FAIL,
    UPLOAD_BATCH_BY_PATIENT_REQUEST, UPLOAD_BATCH_BY_PATIENT_SUCCESS, UPLOAD_BATCH_BY_PATIENT_FAIL,
    UPLOAD_BATCH_BY_STATUS_REQUEST, UPLOAD_BATCH_BY_STATUS_SUCCESS, UPLOAD_BATCH_BY_STATUS_FAIL,
    UPLOAD_BATCH_BY_FILEPATH_REQUEST, UPLOAD_BATCH_BY_FILEPATH_SUCCESS, UPLOAD_BATCH_BY_FILEPATH_FAIL,
    UPLOAD_BATCH_SUBJECTS_REQUEST, UPLOAD_BATCH_SUBJECTS_SUCCESS, UPLOAD_BATCH_SUBJECTS_FAIL,
    UPLOAD_BATCH_SEND_BATCH_REQUEST, UPLOAD_BATCH_SEND_BATCH_SUCCESS, UPLOAD_BATCH_SEND_BATCH_FAIL, UPLOAD_BATCH_SEND_BATCH_RESET,
} from '../constants/uploadBatchConstants';

export const uploadBatchListReducer = (state = { uploadBatches: [] }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_LIST_REQUEST:
            return { ...state, loading: true, uploadBatches: [] };
        case UPLOAD_BATCH_LIST_SUCCESS: {
            const p = action.payload ?? {};
            const totalCount = p.totalCount ?? p.TotalCount ?? 0;
            return {
                loading: false,
                uploadBatches: p.items ?? p.Items ?? [],
                totalPages: p.totalPages ?? p.TotalPages ?? 1,
                currentPage: p.currentPage ?? p.CurrentPage ?? 1,
                totalCount,
                statistics: p.statistics ?? p.Statistics,
            };
        }
        case UPLOAD_BATCH_LIST_FAIL:
            return { loading: false, uploadBatches: [], error: action.payload };
        default:
            return state;
    }
};

export const uploadBatchListByIdsReducer = (state = { uploadBatches: [] }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_LIST_BY_IDS_REQUEST:
            return { loading: true, uploadBatches: [] };
        case UPLOAD_BATCH_LIST_BY_IDS_SUCCESS:
            return { loading: false, uploadBatches: action.payload,
            };
        case UPLOAD_BATCH_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload, uploadBatches: [] };
        default:
            return state;
    }
};

export const uploadBatchDetailsReducer = (state = { uploadBatch: {} }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_DETAILS_REQUEST:
            return { loading: true, ...state };
        case UPLOAD_BATCH_DETAILS_SUCCESS:
            return { loading: false, uploadBatch: action.payload };
        case UPLOAD_BATCH_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case UPLOAD_BATCH_DETAILS_RESET:
            return { uploadBatch: {} };
        default:
            return state;
    }
};

export const uploadBatchDtoReducer = (state = { uploadBatchDto: {} }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_DTO_REQUEST:
            return { loading: true, uploadBatchDto: {} };
        case UPLOAD_BATCH_DTO_SUCCESS:
            return { loading: false, uploadBatchDto: action.payload };
        case UPLOAD_BATCH_DTO_FAIL:
            return { loading: false, error: action.payload };
        case UPLOAD_BATCH_DTO_RESET:
            return { uploadBatchDto: {} };
        default:
            return state;
    }
};

export const uploadBatchDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_DELETE_REQUEST:
            return { loading: true };
        case UPLOAD_BATCH_DELETE_SUCCESS:
            return { loading: false, success: true };
        case UPLOAD_BATCH_DELETE_FAIL:
            return { loading: false, error: action.payload };
        case UPLOAD_BATCH_DELETE_RESET:
            return {};
        default:
            return state;
    }
};

export const uploadBatchCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_CREATE_REQUEST:
            return { loading: true };
        case UPLOAD_BATCH_CREATE_SUCCESS:
            return { loading: false, success: true, uploadBatch: action.payload };
        case UPLOAD_BATCH_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case UPLOAD_BATCH_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const uploadBatchUpdateReducer = (state = { uploadBatch: {} }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_UPDATE_REQUEST:
            return { loading: true };
        case UPLOAD_BATCH_UPDATE_SUCCESS:
            return { loading: false, success: true, uploadBatch: action.payload };
        case UPLOAD_BATCH_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case UPLOAD_BATCH_UPDATE_RESET:
            return { uploadBatch: {} };
        default:
            return state;
    }
};

// Custom reducers for UploadBatch specific functionality
export const uploadBatchByOrganisationReducer = (state = { uploadBatches: [] }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_BY_ORGANISATION_REQUEST:
            return { loading: true, uploadBatches: [] };
        case UPLOAD_BATCH_BY_ORGANISATION_SUCCESS:
            return { loading: false, uploadBatches: action.payload };
        case UPLOAD_BATCH_BY_ORGANISATION_FAIL:
            return { loading: false, error: action.payload, uploadBatches: [] };
        default:
            return state;
    }
};

export const uploadBatchByPatientReducer = (state = { uploadBatches: [] }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_BY_PATIENT_REQUEST:
            return { loading: true, uploadBatches: [] };
        case UPLOAD_BATCH_BY_PATIENT_SUCCESS:
            return { loading: false, uploadBatches: action.payload };
        case UPLOAD_BATCH_BY_PATIENT_FAIL:
            return { loading: false, error: action.payload, uploadBatches: [] };
        default:
            return state;
    }
};

export const uploadBatchByStatusReducer = (state = { uploadBatches: [] }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_BY_STATUS_REQUEST:
            return { loading: true, uploadBatches: [] };
        case UPLOAD_BATCH_BY_STATUS_SUCCESS:
            return { loading: false, uploadBatches: action.payload };
        case UPLOAD_BATCH_BY_STATUS_FAIL:
            return { loading: false, error: action.payload, uploadBatches: [] };
        default:
            return state;
    }
};

export const uploadBatchByFilePathReducer = (state = { uploadBatch: null }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_BY_FILEPATH_REQUEST:
            return { loading: true, uploadBatch: null };
        case UPLOAD_BATCH_BY_FILEPATH_SUCCESS:
            return { loading: false, uploadBatch: action.payload };
        case UPLOAD_BATCH_BY_FILEPATH_FAIL:
            return { loading: false, error: action.payload, uploadBatch: null };
        default:
            return state;
    }
};

export const uploadBatchSubjectsReducer = (state = { subjects: [] }, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_SUBJECTS_REQUEST:
            return { loading: true, subjects: [] };
        case UPLOAD_BATCH_SUBJECTS_SUCCESS:
            return {
                loading: false,
                subjects: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.page,
                totalCount: action.payload.totalCount,
            };
        case UPLOAD_BATCH_SUBJECTS_FAIL:
            return { loading: false, error: action.payload, subjects: [] };
        default:
            return state;
    }
};

export const uploadBatchSendBatchReducer = (state = {}, action) => {
    switch (action.type) {
        case UPLOAD_BATCH_SEND_BATCH_REQUEST:
            return { loading: true };
        case UPLOAD_BATCH_SEND_BATCH_SUCCESS:
            return { loading: false, success: true, updatedCount: action.payload.updatedCount };
        case UPLOAD_BATCH_SEND_BATCH_FAIL:
            return { loading: false, error: action.payload };
        case UPLOAD_BATCH_SEND_BATCH_RESET:
            return {};
        default:
            return state;
    }
}; 